import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState, } from "react";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import { AppBar, Box, Button, Drawer, List, Stack, Toolbar, useTheme, } from "@mui/material";
import { CloseAppDrawerProvider } from "./AppDrawerContext.js";
import { AppDrawerDivider, AppDrawerListItem } from "./AppDrawerItems.js";
export const AppDrawerMobile = ({ drawerWidth = "15.625rem", logo, drawerItems, children, appDrawerColor, hoverColor, }) => {
    const theme = useTheme();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [menuButtonWidth, setMenuButtonWidth] = useState(72);
    const menuButtonRef = useRef(null);
    const closeDrawer = useCallback(() => {
        setDrawerOpen(false);
    }, []);
    useEffect(() => {
        const menuButtonElement = menuButtonRef.current;
        if (!menuButtonElement) {
            return;
        }
        const updateMenuButtonWidth = () => {
            const width = menuButtonElement.getBoundingClientRect().width;
            setMenuButtonWidth(width);
        };
        updateMenuButtonWidth();
        const resizeObserver = new ResizeObserver(() => {
            updateMenuButtonWidth();
        });
        resizeObserver.observe(menuButtonElement);
        window.addEventListener("resize", updateMenuButtonWidth);
        return () => {
            resizeObserver.disconnect();
            window.removeEventListener("resize", updateMenuButtonWidth);
        };
    }, []);
    return (_jsxs(Box, { sx: { display: "flex", flexDirection: "column" }, children: [_jsx(AppBar, { position: "sticky", sx: {
                    display: "flex",
                    maxHeight: "4rem",
                    backgroundColor: appDrawerColor ?? theme.palette.primary.main,
                }, children: _jsx(Toolbar, { sx: {
                        minHeight: "4rem !important",
                    }, children: _jsxs(Box, { sx: {
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            height: "4rem",
                            width: "100%",
                            overflow: "hidden",
                        }, children: [_jsx(Button, { ref: menuButtonRef, sx: {
                                    maxWidth: "fit-content",
                                    zIndex: 1,
                                }, color: "inherit", startIcon: _jsx(MenuIcon, {}), "aria-label": "menu", "data-testid": "menu-button", onClick: () => {
                                    setDrawerOpen(true);
                                }, children: "Menu" }), _jsx(Box, { sx: {
                                    position: "absolute",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    width: `min(100%, calc(100% - ${String(menuButtonWidth * 2)}px))`,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    top: 0,
                                    bottom: 0,
                                    pointerEvents: "none",
                                    "& > *": {
                                        maxWidth: "100%",
                                        maxHeight: "100%",
                                    },
                                    "& img, & svg": {
                                        maxWidth: "100%",
                                        maxHeight: "100%",
                                        width: "auto",
                                        height: "auto",
                                    },
                                }, children: logo })] }) }) }), _jsx(Drawer, { open: drawerOpen, onClose: closeDrawer, slotProps: {
                    paper: {
                        sx: {
                            backgroundColor: appDrawerColor ?? theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                        },
                    },
                }, children: _jsx(CloseAppDrawerProvider, { value: closeDrawer, children: _jsxs(Stack, { component: "nav", "aria-label": "Main navigation", sx: { width: drawerWidth, flexGrow: 1 }, children: [_jsx(List, { children: _jsx(AppDrawerListItem, { text: "Close", icon: _jsx(CloseIcon, {}), hoverColor: hoverColor }) }), _jsx(AppDrawerDivider, {}), drawerItems] }) }) }), children] }));
};
//# sourceMappingURL=AppDrawerMobile.js.map